import React from "react";

import SavedSuppliersRoute from "../../features/favourites/SavedSuppliersRoute";
import HexAuthWrapper from "../../components/HexAuthWrapper";

const SavedSuppliers = () => (
  <div className="saved-suppliers-page full-bleed">
    <HexAuthWrapper>
      <SavedSuppliersRoute />
    </HexAuthWrapper>
  </div>
);

export default SavedSuppliers;
